module.exports = __webpack_public_path__ + "static/media/notification.2dec628d.svg";